import React from "react";
import ReactDOM from "react-dom/client";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, skipWaiting } from "@/serviceWorkerRegistration";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// "New version available — tap to refresh" prompt. Stays open until the
// user opts in; the controllerchange handler in serviceWorkerRegistration
// reloads the page once the new SW activates.
registerServiceWorker({
  onUpdate: (registration) => {
    toast(
      "✨ New version of OneVoice available",
      {
        description: "Tap to refresh and get the latest features.",
        action: {
          label: "Refresh",
          onClick: () => skipWaiting(registration),
        },
        duration: Infinity,
        // Anchor the toast so it can't be missed mid-edit
        position: "bottom-right",
      },
    );
  },
});
